import { AFFILIATE_PROGRAM_API } from 'modules/affiliate-program/api/affiliate-program-api'
import { CommissionApiInterface } from 'modules/affiliate-program/types/affiliate-program-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface'
import { baseFetcher } from 'shared/utils/http-client'
import useSWR from 'swr'

export function useCommissions({ limit, pagination }: SwrPaginationInterface) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, CommissionApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: commissions, mutate: mutateCommissions } = useSWR(() => {
    if (user && pagination.startFromId === undefined && limit) {
      return `${AFFILIATE_PROGRAM_API}/affiliate-commissions/list?pagination[limit]=${limit}`
    } else if (user && pagination.startFromId && limit) {
      return `${AFFILIATE_PROGRAM_API}/affiliate-commissions/list?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}`
    }
    return null
  }, fetcher)

  const { data: commissionsCounter } = useSWR<CountInterface>(() => {
    if (user) {
      return `${AFFILIATE_PROGRAM_API}/affiliate-commissions/count`
    }
    return null
  }, baseFetcher)

  return { commissions, mutateCommissions, commissionsCounter }
}
